import withSpacing from '../../decorators/withSpacing/index';
import Checkbox from './Checkbox';
export default withSpacing(Checkbox);
//# sourceMappingURL=index.js.map